<div class="segment">
  <button
    mat-icon-button
    type="button"
    tabindex="-1"
    aria-label="Ubrať hodinu"
    [disabled]="disabled()"
    (click)="step('hours', -1)"
    (blur)="touch.emit()"
  >
    <mat-icon class="step-icon">remove</mat-icon>
  </button>
  <input
    #hours
    type="text"
    role="spinbutton"
    inputmode="numeric"
    autocomplete="off"
    placeholder="--"
    aria-label="Hodiny"
    aria-valuemin="0"
    cdkFocusInitial
    [attr.aria-valuemax]="segmentMax.hours"
    [attr.aria-valuenow]="segmentValue('hours')"
    [attr.aria-valuetext]="text('hours') || null"
    [value]="text('hours')"
    [disabled]="disabled()"
    [attr.aria-invalid]="showError()"
    (input)="onInput('hours', $event)"
    (keydown)="onKeydown('hours', $event)"
    (blur)="onBlur('hours')"
  />
  <button
    mat-icon-button
    type="button"
    tabindex="-1"
    aria-label="Pridať hodinu"
    [disabled]="disabled()"
    (click)="step('hours', 1)"
    (blur)="touch.emit()"
  >
    <mat-icon class="step-icon">add</mat-icon>
  </button>
</div>
<span class="separator" aria-hidden="true">:</span>
<div class="segment">
  <button
    mat-icon-button
    type="button"
    tabindex="-1"
    aria-label="Ubrať 5 minút"
    [disabled]="disabled()"
    (click)="step('minutes', -1)"
    (blur)="touch.emit()"
  >
    <mat-icon class="step-icon">remove</mat-icon>
  </button>
  <input
    #minutes
    type="text"
    role="spinbutton"
    inputmode="numeric"
    autocomplete="off"
    placeholder="--"
    aria-label="Minúty"
    aria-valuemin="0"
    [attr.aria-valuemax]="segmentMax.minutes"
    [attr.aria-valuenow]="segmentValue('minutes')"
    [attr.aria-valuetext]="text('minutes') || null"
    [value]="text('minutes')"
    [disabled]="disabled()"
    [attr.aria-invalid]="showError()"
    (input)="onInput('minutes', $event)"
    (keydown)="onKeydown('minutes', $event)"
    (blur)="onBlur('minutes')"
  />
  <button
    mat-icon-button
    type="button"
    tabindex="-1"
    aria-label="Pridať 5 minút"
    [disabled]="disabled()"
    (click)="step('minutes', 1)"
    (blur)="touch.emit()"
  >
    <mat-icon class="step-icon">add</mat-icon>
  </button>
</div>
